import { render, staticRenderFns } from "./AllAssessment.vue?vue&type=template&id=0aaeed1a&scoped=true"
import script from "./AllAssessment.vue?vue&type=script&lang=js"
export * from "./AllAssessment.vue?vue&type=script&lang=js"
import style0 from "./AllAssessment.vue?vue&type=style&index=0&id=0aaeed1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaeed1a",
  null
  
)

export default component.exports